<template>
  <div class="AppointmentsModal">
    <div class="m-modal" v-show="modal.isShow" transition="expand">
      <div class="m-modal__inner">
        <i class="fas fa-trash-restore no-print" @click="reset"></i>
        <router-link to="/"><i class="fas fa-times no-print"></i></router-link>

        <div class="m-modal__inner__content" style="width: 795px">
          <div style="display: flex">
            <table style="flex: 2">
              <tr>
                <th>
                  状態
                  <span class="req">*</span>
                </th>
                <td colspan="3">
                  <div>
                    <input
                      type="checkbox"
                      id="medium_value_2"
                      value="2"
                      v-model="appointment.mediumArray"
                    />
                    <label for="medium_value_2">貼紙</label>

                    <span>HP閲覧</span>
                    <input type="text" v-model="appointment.shop_name" />

                    <span>HP閲覧</span>
                    <input
                      type="radio"
                      id="hp_browse_value_1"
                      value="1"
                      v-model="appointment.hp_browse"
                    />
                    <label for="hp_browse_value_1">PC</label>
                    <input
                      type="radio"
                      id="hp_browse_value_2"
                      value="2"
                      v-model="appointment.hp_browse"
                    />
                    <label for="hp_browse_value_2">スマホ</label>
                    <input
                      type="radio"
                      id="hp_browse_value_3"
                      value="3"
                      v-model="appointment.hp_browse"
                    />
                    <label for="hp_browse_value_3">両方</label>
                    <input
                      type="radio"
                      id="hp_browse_value_4"
                      value="4"
                      v-model="appointment.hp_browse"
                    />
                    <label for="hp_browse_value_4">非閲覧</label>
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="medium_value_4"
                      value="4"
                      v-model="appointment.mediumArray"
                    />
                    <label for="medium_value_4">紹介</label>
                    <input type="text" />
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="medium_value_3"
                      value="3"
                      v-model="appointment.mediumArray"
                    />
                    <label for="medium_value_3">HP</label>
                    <input
                      type="radio"
                      id="hp_type_value_2"
                      value="2"
                      v-model="appointment.hp_type"
                    />
                    <label for="hp_type_value_2">WEB</label>
                    <!-- リスティング？ -->
                    <input
                      type="radio"
                      id="hp_type_value_1"
                      value="1"
                      v-model="appointment.hp_type"
                    />
                    <label for="hp_type_value_1">自社</label>

                    <input
                      type="checkbox"
                      id="hp_type_value_8"
                      value="8"
                      v-model="appointment.mediumArray"
                    />
                    <label for="hp_type_value_8">一括資料請求</label>

                    <input type="checkbox" id="denwa" v-model="ichiji.denwa" />
                    <label for="denwa">電話</label>

                    <input type="checkbox" id="fd" v-model="ichiji.fd"/>
                    <label for="fd">FD</label>

                    <input type="checkbox" id="toifd" v-model="ichiji.toifd" />
                    <label for="toifd">問FD</label>
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="medium_value_7"
                      value="7"
                      v-model="appointment.mediumArray"
                    />
                    <label for="medium_value_7">その他</label>
                    <input type="text" v-model="ichiji.other"/>
                  </div>
                </td>
              </tr>

              <tr>
                <th>ニーズ</th>
                <td>
                  <input type="radio" id="ap_type_value_1" value="1" v-model="appointment.ap_type" />
                  <label for="ap_type_value_1">体験</label>
                  <input type="radio" id="ap_type_value_2" value="2" v-model="appointment.ap_type" />
                  <label for="ap_type_value_2">資料</label>
                  <input type="radio" id="ap_type_value_3" value="3" v-model="appointment.ap_type" />
                  <label for="ap_type_value_3">問合</label>
                </td>

                <th>AP設定</th>
                <td>
                  <input type="radio" id="ap_settei_1" v-model="ichiji.ap_settei" value="1" />
                  <label for="ap_settei_1">堅い</label>
                  <input type="radio" id="ap_settei_2" v-model="ichiji.ap_settei" value="2" />
                  <label for="ap_settei_2">普通</label>
                  <input type="radio" id="ap_settei_3" v-model="ichiji.ap_settei" value="3" />
                  <label for="ap_settei_3">緩い</label>
                </td>
              </tr>

              <tr>
                <th>話した人</th>
                <td colspan="3">
                  <input
                    type="radio"
                    id="contact_person_value_1"
                    v-model="appointment.contact_person"
                    value="1"
                  />
                  <label for="contact_person_value_1">母</label>
                  <input
                    type="radio"
                    id="contact_person_value_2"
                    v-model="appointment.contact_person"
                    value="2"
                  />
                  <label for="contact_person_value_2">父</label>
                  <input
                    type="radio"
                    id="contact_person_value_5"
                    v-model="appointment.contact_person"
                    value="5"
                  />
                  <label for="contact_person_value_5">子</label>
                  <input
                    type="radio"
                    id="contact_person_value_3"
                    v-model="appointment.contact_person"
                    value="3"
                  />
                  <label for="contact_person_value_3">祖母</label>
                  <input
                    type="radio"
                    id="contact_person_value_4"
                    v-model="appointment.contact_person"
                    value="4"
                  />
                  <label for="contact_person_value_4">祖父</label>
                  <span>他</span>
                  <input type="text" v-model="ichiji.contact_person_other" style="width: 100px" />
                  <span>タイプ</span>
                  <input type="text" v-model="ichiji.contact_person_type" style="width: 100px" />
                </td>
              </tr>
            </table>

            <table style="flex: 1">
              <tr>
                <th>
                  資料送付
                  <span class="req">*</span>
                </th>
                <td>
                  <input
                    type="radio"
                    id="sending_method_value_1"
                    v-model="appointment.sending_method"
                    value="1"
                  />
                  <label for="sending_method_value_1">郵送</label>

                  <input
                    type="radio"
                    id="sending_method_value_2"
                    v-model="appointment.sending_method"
                    value="2"
                  />
                  <label for="sending_method_value_2">FAX</label>

                  <input
                    type="radio"
                    id="sending_method_value_3"
                    v-model="appointment.sending_method"
                    value="3"
                  />
                  <label for="sending_method_value_3">メール</label>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <div>
                    <input
                      type="checkbox"
                      id="sending_products_value_1"
                      value="体験案内"
                      v-model="appointment.sending_productsArray"
                    />
                    <label for="sending_products_value_1">体験案内</label>

                    <input
                      type="checkbox"
                      id="sending_products_value_2"
                      value="資料"
                      v-model="appointment.sending_productsArray"
                    />
                    <label for="sending_products_value_2">資料</label>

                    <input
                      type="checkbox"
                      id="sending_products_value_3"
                      value="料金表"
                      v-model="appointment.sending_productsArray"
                    />
                    <label for="sending_products_value_3">料金表</label>

                    <input
                      type="checkbox"
                      id="sending_products_value_4"
                      value="Quoカード"
                      v-model="appointment.sending_productsArray"
                    />
                    <label for="sending_products_value_4">Quoカード</label>
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="sending_products_value_5"
                      value="ギフトカード"
                      v-model="appointment.sending_productsArray"
                    />
                    <label for="sending_products_value_5">ギフトカード</label>

                    <input
                      type="checkbox"
                      id="sending_products_value_6"
                      value="キャンペーンチラシ"
                      v-model="appointment.sending_productsArray"
                    />
                    <label for="sending_products_value_6">キャンペーンチラシ</label>
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="sending_products_value_7"
                      value="送らない"
                      v-model="appointment.sending_productsArray"
                    />
                    <label for="sending_products_value_7">送らない</label>
                  </div>
                </td>
              </tr>

              <tr>
                <th>
                  日付
                  <span class="req">*</span>
                </th>
                <td>
                  <div>
                    <input type="text" v-model="appointment.sending_date" placeholder="日付" style="width: 90px" />
                    <input type="text" v-model="appointment.sending_time" placeholder="時間" style="width: 90px" />
                  </div>
                </td>
              </tr>

              <tr>
                <th>担当</th>
                <td>
                  <input type="text" v-model="ichiji.siryo_person" style="width: 199px" />
                </td>
              </tr>
            </table>
          </div>

          <table>
            <tr>
              <th>
                日付
                <span class="req">*</span>
              </th>
              <td>
                <input
                  type="text"
                  v-model="appointment.acquisition_date"
                  placeholder="取得日"
                   style="width: 120px; height: 26px"
                />
                <input type="text" v-model="ichiji.acquisition_youbi" placeholder="曜日" style="width: 70px; height: 26px" />
                <input type="text" v-model="ichiji.acquisition_time" placeholder="時間"  style="width: 120px; height: 26px"/>
              </td>

              <th>状態</th>
              <td colspan="">
                <multiselect
                  v-model="watch.state"
                  :options="state"
                  label="name"
                  :searchable="true"
                  :show-labels="false"
                  placeholder=""
                ></multiselect>
              </td>

              <th>受付担当</th>
              <td colspan="">
                <input type="text" v-model="appointment.person" style="height: 26px" />
              </td>
            </tr>

            <tr>
              <th rowspan="2">生徒名①</th>
              <td>
                <input
                  type="text"
                  v-model="appointment.f_name_kana"
                  placeholder="みょうじ"
                  style="width: 120px; height: 26px"
                />
                <input
                  type="text"
                  v-model="appointment.l_name_kana"
                  placeholder="かな"
                  style="width: 120px; height: 26px"
                />
              </td>

              <th>学年</th>
              <td>
                <div style="display: flex">
                  <div style="width: 100px">
                    <multiselect
                      v-model="watch.school_stage"
                      :options="school_stage"
                      label="name"
                      :searchable="false"
                      :show-labels="false"
                      placeholder=""
                    ></multiselect>
                  </div>
                  <div style="width: 50px">
                    <multiselect
                      v-model="watch.grade"
                      :options="grade"
                      label="name"
                      :searchable="false"
                      :show-labels="false"
                      placeholder=""
                    ></multiselect>
                  </div>
                </div>
              </td>

              <th>部活</th>
              <td>
                <input type="text" v-model="ichiji.bukatsu" placeholder="部活" style="height: 26px" />
              </td>
            </tr>

            <tr>
              <td>
                <input
                  type="text"
                  v-model="appointment.f_name"
                  placeholder="苗字"
                  style="width: 120px; height: 40px"
                />
                <input
                  type="text"
                  v-model="appointment.l_name"
                  placeholder="名前"
                  style="width: 120px; height: 40px"
                />

                <input type="radio" id="gender_value_1" v-model="appointment.gender" value="1" />
                <label for="gender_value_1">男</label>
                <input type="radio" id="gender_value_2" v-model="appointment.gender" value="2" />
                <label for="gender_value_2">女</label>
              </td>

              <th>学校名</th>
              <td colspan="3">
                <div>
                  <input
                    type="radio"
                    id="school_type_value_1"
                    v-model="appointment.school_type"
                    value="1"
                  />
                  <label for="school_type_value_1">公</label>

                  <input
                    type="radio"
                    id="school_type_value_3"
                    v-model="appointment.school_type"
                    value="3"
                  />
                  <label for="school_type_value_3">私</label>

                  <input
                    type="radio"
                    id="school_type_value_2"
                    v-model="appointment.school_type"
                    value="2"
                  />
                  <label for="school_type_value_2">国</label>

                  <span>学校名</span>
                  <input type="text" v-model="appointment.school_name" style="width: 200px" />
                </div>
                <div>
                  <input type="radio" id="bunri_value_1" v-model="ichiji.bunri" value="1" />
                  <label for="bunri_value_1">文</label>

                  <input type="radio" id="bunri_value_2" v-model="ichiji.bunri" value="2" />
                  <label for="bunri_value_2">理</label>

                  <span>コース</span>
                  <input type="text" v-model="ichiji.cource" style="width: 200px; margin-left: 32px" />
                </div>
              </td>
            </tr>

            <tr>
              <th rowspan="2">生徒名②</th>
              <td>
                <input
                  type="text"
                  v-model="appointment.sub_f_name_kana"
                  placeholder="みょうじ"
                  style="width: 120px; height: 26px"
                />
                <input
                  type="text"
                  v-model="appointment.sub_l_name_kana"
                  placeholder="なまえ"
                  style="width: 120px; height: 26px"
                />
              </td>

              <th>学年</th>
              <td>
                <div style="display: flex">
                  <div style="width: 100px">
                    <multiselect
                      v-model="watch.sub_school_stage"
                      :options="school_stage"
                      label="name"
                      :searchable="false"
                      :show-labels="false"
                      placeholder=""
                    ></multiselect>
                  </div>
                  <div style="width: 50px">
                    <multiselect
                      v-model="watch.sub_grade"
                      :options="grade"
                      label="name"
                      :searchable="false"
                      :show-labels="false"
                      placeholder=""
                    ></multiselect>
                  </div>
                </div>
              </td>

              <th>部活</th>
              <td>
                <input type="text" v-model="ichiji.sub_bukatsu" placeholder="部活" style="height: 26px" />
              </td>
            </tr>

            <tr>
              <td>
                <input
                  type="text"
                  v-model="appointment.sub_f_name"
                  placeholder="苗字"
                  style="width: 120px; height: 40px"
                />
                <input
                  type="text"
                  v-model="appointment.sub_l_name"
                  placeholder="名前"
                  style="width: 120px; height: 40px"
                />

                <input type="radio" id="sub_gender_value_1" v-model="appointment.sub_gender" value="1" />
                <label for="sub_gender_value_1">男</label>
                <input type="radio" id="sub_gender_value_2" v-model="appointment.sub_gender" value="2" />
                <label for="sub_gender_value_2">女</label>
              </td>

              <th>学校名</th>
              <td colspan="3">
                <div>
                  <input
                    type="radio"
                    id="sub_school_type_value_1"
                    v-model="appointment.sub_school_type"
                    value="1"
                  />
                  <label for="sub_school_type_value_1">公</label>

                  <input
                    type="radio"
                    id="sub_school_type_value_3"
                    v-model="appointment.sub_school_type"
                    value="3"
                  />
                  <label for="sub_school_type_value_3">私</label>

                  <input
                    type="radio"
                    id="sub_school_type_value_2"
                    v-model="appointment.sub_school_type"
                    value="2"
                  />
                  <label for="sub_school_type_value_2">国</label>

                  <span>学校名</span>
                  <input type="text" v-model="appointment.sub_school_name" style="width: 200px" />
                </div>
                <div>
                  <input type="radio" id="sub_bunri_value_1" v-model="ichiji.sub_bunri" value="1" />
                  <label for="sub_bunri_value_1">文</label>

                  <input type="radio" id="sub_bunri_value_2" v-model="ichiji.sub_bunri" value="2" />
                  <label for="sub_bunri_value_2">理</label>

                  <span>コース</span>
                  <input type="text" v-model="ichiji.cource" style="width: 200px; margin-left: 32px" />
                </div>
              </td>
            </tr>

            <tr>
              <th rowspan="2">
                住所
                <span class="req">*</span>
              </th>
              <td>
                <div style="display: flex">
                  <span>〒</span>
                  <input type="text" v-model="appointment.zip" @keyup="getYubin" style="height: 26px" />
                  <multiselect
                    v-model="watch.pref"
                    :options="prefs"
                    label="name"
                    :searchable="true"
                    :show-labels="false"
                    placeholder="都道府県"
                  ></multiselect>
                </div>
              </td>

              <th>固定</th>
              <td colspan="">
                <input type="text" v-model="appointment.tel2" style="height: 26px" />
              </td>
              <th>MAIL</th>
              <td colspan="">
                <input type="text" v-model="appointment.mail" style="height: 26px" />
              </td>
            </tr>

            <tr>
              <td>
                <input
                  type="text"
                  v-model="appointment.address1"
                  placeholder="住所1"
                  style="width: 160px"
                />
                <input
                  type="text"
                  v-model="appointment.address2"
                  placeholder="住所2"
                  style="width: 160px"
                />
              </td>

              <th>携帯</th>
              <td colspan="">
                <input type="text" v-model="appointment.tel1" />
              </td>
              <th>FAX</th>
              <td colspan="">
                <input type="text" v-model="appointment.fax" />
              </td>
            </tr>

            <tr>
              <th>最寄り駅</th>
              <td colspan="5">
                <input type="text" v-model="ichiji.station" style="width: 100px" />
                <span>駅／</span>

                <input type="checkbox" id="toho" v-model="ichiji.toho" />
                <label for="toho">徒歩</label>

                <input type="text" v-model="ichiji.minutes" style="width: 90px" />
                <span>分</span>

                <input type="checkbox" id="bus" v-model="ichiji.bus" />
                <label for="bus">バス</label>

                <span>最終</span>
                <input type="text" v-model="ichiji.bus_time" style="width: 100px" />

                <span>駐車場</span>

                <input type="radio" id="parking_value_1" v-model="appointment.parking" value="1" />
                <label for="parking_value_1">有</label>

                <input type="radio" id="parking_value_2" v-model="appointment.parking" value="2" />
                <label for="parking_value_2">無</label>

                <input type="checkbox" id="parking_home" v-model="ichiji.parking_home" />
                <label for="parking_home">自宅</label>

                <input type="checkbox" id="parking_raikyaku" v-model="ichiji.parking_raikyaku" />
                <label for="parking_raikyaku">来客用</label>

                <input type="checkbox" id="parking_coin" v-model="ichiji.parking_coin" />
                <label for="parking_coin">コインP</label>
              </td>
            </tr>

            <tr>
              <th>
                訪問日時
                <span class="req">*</span>
              </th>
              <td colspan="2">
                <input
                  type="text"
                  v-model="appointment.visit_date"
                  placeholder="年月日"
                  style="width: 100px"
                />
                <input type="text" v-model="ichiji.visit_youbi" placeholder="曜日" style="width: 50px" />
                <input
                  type="text"
                  v-model="appointment.visit_time"
                  placeholder="時間"
                  style="width: 100px"
                />
              </td>

              <td colspan="3">
                <div>
                  <span>前確</span>
                  <input
                    type="radio"
                    id="preferred_contact_2"
                    v-model="appointment.preferred_contact"
                    value="2"
                  />
                  <label for="preferred_contact_2">携帯</label>

                  <input
                    type="radio"
                    id="preferred_contact_1"
                    v-model="appointment.preferred_contact"
                    value="1"
                  />
                  <label for="preferred_contact_1">自宅</label>

                  <input
                    type="radio"
                    id="preferred_contact_5"
                    v-model="appointment.preferred_contact"
                    value="5"
                  />
                  <label for="preferred_contact_5">SMS</label>

                  <input type="checkbox" id="hayame" v-model="ichiji.hayame" />
                  <label for="hayame">12-14or</label>

                  <input
                    type="text"
                    style="width: 40px"
                    v-model="appointment.contact_timezone"
                    placeholder="時間"
                  />

                  <input
                    type="checkbox"
                    id="confirm_check_value_1"
                    v-model="appointment.confirm_check"
                    value="1"
                  />
                  <label for="confirm_check_value_1">済</label>

                  <input type="text" v-model="ichiji.zenkaku_note" style="width: 30px" />
                </div>
              </td>
            </tr>

            <tr>
              <th>当日参加者</th>
              <td colspan="5">
                <input
                  type="checkbox"
                  id="attended_value_1"
                  v-model="appointment.attendedArray"
                  value="母"
                />
                <label for="attended_value_1">母</label>

                <input
                  type="checkbox"
                  id="attended_value_2"
                  v-model="appointment.attendedArray"
                  value="父"
                />
                <label for="attended_value_2">父</label>

                <input
                  type="checkbox"
                  id="attended_value_3"
                  v-model="appointment.attendedArray"
                  value="子"
                />
                <label for="attended_value_3">子</label>

                <input
                  type="checkbox"
                  id="attended_value_4"
                  v-model="appointment.attendedArray"
                  value="祖母"
                />
                <label for="attended_value_4">祖母</label>

                <input
                  type="checkbox"
                  id="attended_value_5"
                  v-model="appointment.attendedArray"
                  value="祖父"
                />
                <label for="attended_value_5">祖父</label>

                <input type="checkbox" id="attended_value_6" v-model="ichiji.attended_other" />
                <label for="attended_value_6">他</label>

                <input type="text" v-model="ichiji.attended_other_note" />

                <input type="checkbox" id="oshirase" v-model="ichiji.oshirase" />
                <label for="oshirase">空きが出たらお知らせ希望</label>

                <input type="radio" id="aki_value_1" v-model="ichiji.aki" value="1" />
                <label for="aki_value_1">有</label>

                <input type="radio" id="aki_value_2" v-model="ichiji.aki" value="2" />
                <label for="aki_value_2">無</label>

                <input type="checkbox" id="mikakunin" v-model="ichiji.mikakunin" />
                <label for="mikakunin">未確認</label>
              </td>
            </tr>

            <tr>
              <th>その他</th>
              <td colspan="5">
                <span>備考</span>
                <input type="text" v-model="ichiji.bikou" />
                <label for="">体験第一希望</label>
                <input type="text" v-model="ichiji.kibou1_date" placeholder="月日" style="width: 100px" />
                <input type="text" v-model="ichiji.kibou1_youbi" placeholder="曜日" style="width: 50px" />
                <label for="">体験第二希望</label>
                <input type="text" v-model="ichiji.kibou2_date" placeholder="月日" style="width: 100px" />
                <input type="text" v-model="ichiji.kibou2_youbi" placeholder="曜日" style="width: 50px" />
              </td>
            </tr>
          </table>

          <div style="display: flex">
            <table style="flex: 80%">
              <tr>
                <th>成績</th>
                <th>学習状況</th>
              </tr>

              <tr>
                <td>
                  <div>
                    <span>苦手教科</span>

                    <input type="checkbox" id="ei" v-model="ichiji.ei" />
                    <label for="ei">英</label>

                    <input type="checkbox" id="su" v-model="ichiji.su" />
                    <label for="su">数</label>

                    <input type="checkbox" id="koku" v-model="ichiji.koku" />
                    <label for="koku">国</label>

                    <input type="checkbox" id="ri" v-model="ichiji.ri" />
                    <label for="ri">理</label>

                    <input type="checkbox" id="sya" v-model="ichiji.sya" />
                    <label for="sya">社</label>

                    <input type="checkbox" id="zen" v-model="ichiji.zen"/>
                    <label for="zen">全教科×</label>
                  </div>
                  <div>
                    <span>備考</span>
                    <input type="text" v-model="ichiji.seiseki_note" />
                  </div>
                  <div>
                    <span>定期テスト</span>
                    <input type="text" v-model="ichiji.teiki" style="width: 50px" />
                    <span>/500</span>
                    <span>実力テスト</span>
                    <input type="text" v-model="ichiji.jitsuryoku" style="width: 50px" />
                    <span>/500</span>
                  </div>
                </td>

                <td>
                  <div>
                    <input type="radio" id="shukan_value_1" v-model="ichiji.shukan" value="1" />
                    <label for="shukan_value_1">習慣OK</label>

                    <input type="radio" id="shukan_value_2" v-model="ichiji.shukan" value="2" />
                    <label for="shukan_value_2">宿題程度</label>

                    <input type="radio" id="shukan_value_3" v-model="ichiji.shukan" value="3" />
                    <label for="shukan_value_3">テスト前のみ</label>

                    <input type="radio" id="shukan_value_4" v-model="ichiji.shukan" value="4" />
                    <label for="shukan_value_4">やる気なし</label>
                  </div>
                  <div>
                    <input type="radio" id="shukan_value_5" v-model="ichiji.shukan" value="5" />
                    <label for="shukan_value_5">やり方わからない</label>

                    <input type="radio" id="shukan_value_6" v-model="ichiji.shukan" value="6" />
                    <label for="shukan_value_6">全くしてない</label>

                    <input type="radio" id="shukan_value_7" v-model="ichiji.shukan" value="7" />
                    <label for="shukan_value_7">不明</label>
                  </div>
                  <div>
                    <span>他</span>
                    <input type="text" v-model="ichiji.shukan_note" />
                  </div>
                </td>
              </tr>

              <tr>
                <th>今まで塾、家庭教師などの習い事は？</th>
                <th>バッティング</th>
              </tr>

              <tr>
                <td>
                  <div>
                    <input type="radio" id="naraigoto_value_1" v-model="ichiji.naraigoto" value="1" />
                    <label for="naraigoto_value_1">やっている</label>

                    <input type="radio" id="naraigoto_value_2" v-model="ichiji.naraigoto" value="2" />
                    <label for="naraigoto_value_2">やめた</label>

                    <input type="radio" id="naraigoto_value_3" v-model="ichiji.naraigoto" value="3" />
                    <label for="naraigoto_value_3">やったことない</label>
                  </div>
                  <div>
                    <span>●種類</span>

                    <input type="checkbox" id="naraigoto_type1" v-model="ichiji.naraigoto_type1" />
                    <label for="naraigoto_type1">集団塾</label>

                    <input type="checkbox" id="naraigoto_type2" v-model="ichiji.naraigoto_type2" />
                    <label for="naraigoto_type2">個別塾</label>

                    <input type="checkbox" id="naraigoto_type3" v-model="ichiji.naraigoto_type3" />
                    <label for="naraigoto_type3">家庭教師</label>

                    <input type="checkbox" id="naraigoto_type4" v-model="ichiji.naraigoto_type4" />
                    <label for="naraigoto_type4">教材</label>
                  </div>
                  <div>
                    <span>名称</span>
                    <input type="text" v-model="ichiji.naraigoto_name" style="width: 100px" />
                    <span>週</span>
                    <input type="text" v-model="ichiji.naraigoto_week" style="width: 50px" />
                    <span>回</span>
                    <input type="text" v-model="ichiji.naraigoto_time" style="width: 50px" />
                    <span>分</span>
                    <input type="text" v-model="ichiji.naraigoto_kyouka" style="width: 50px" />
                    <span>教科</span>
                  </div>
                  <div>
                    <span>●辞め理由</span>

                    <input type="checkbox" id="yame_yaruki" v-model="ichiji.yame_yaruki" />
                    <label for="yame_yaruki">やる気</label>

                    <input type="checkbox" id="yame_seiseki" v-model="ichiji.yame_seiseki" />
                    <label for="yame_seiseki">成績</label>

                    <input type="checkbox" id="yame_huniki" v-model="ichiji.yame_huniki" />
                    <label for="yame_huniki">雰囲気</label>

                    <input type="checkbox" id="yame_sensei" v-model="ichiji.yame_sensei" />
                    <label for="yame_sensei">先生</label>
                  </div>
                  <div>
                    <span>他</span>
                    <input type="text" v-model="ichiji.yame_other" />
                  </div>
                  <div>
                    <span>●検討状況</span>

                    <input type="radio" id="kento_value_1" v-model="ichiji.kento" value="1" />
                    <label for="kento_value_1">切替</label>

                    <input type="radio" id="kento_value_2" v-model="ichiji.kento" value="2" />
                    <label for="kento_value_2">併行する</label>

                    <input type="radio" id="kento_value_3" v-model="ichiji.kento" value="3" />
                    <label for="kento_value_3">検討中</label>
                  </div>
                </td>

                <td>
                  <div>
                    <span>●今まで体験きいたことは？</span>
                  </div>
                  <div>
                    <input type="radio" id="kiitakoto_value_1" v-model="ichiji.kiitakoto" value="1" />
                    <label for="kiitakoto_value_1">なし</label>

                    <input type="radio" id="kiitakoto_value_2" v-model="ichiji.kiitakoto" value="2" />
                    <label for="kiitakoto_value_2">あり</label>

                    <input type="text" v-model="ichiji.kiitakoto_note" />
                  </div>
                  <div>
                    <span>●他に体験聞く予定は？</span>
                  </div>
                  <div>
                    <input type="radio" id="kikuyotei_value_1" v-model="ichiji.kikuyotei" value="1" />
                    <label for="kikuyotei_value_1">なし</label>

                    <input type="radio" id="kikuyotei_value_2" v-model="ichiji.kikuyotei" value="2" />
                    <label for="kikuyotei_value_2">あり</label>

                    <input type="text" v-model="ichiji.kikuyotei_note" />
                  </div>
                  <div>
                    <input type="checkbox" id="batting" v-model="ichiji.batting" />
                    <label for="batting">バッティングのおさえ</label>
                  </div>
                </td>
              </tr>

              <tr>
                <th>志望校 ※小学生、高校生は必ず聞く事！</th>
                <th>保護者ニーズ</th>
              </tr>

              <tr>
                <td>
                  <div>
                    <span>●受験希望</span>
                  </div>
                  <div>
                    <input type="radio" id="jukenkibou_value_1" v-model="ichiji.jukenkibou" value="1" />
                    <label for="jukenkibou_value_1">なし</label>

                    <input type="radio" id="jukenkibou_value_2" v-model="ichiji.jukenkibou" value="2" />
                    <label for="jukenkibou_value_2">あり</label>

                    <span>／志望校</span>
                    <input type="text" v-model="ichiji.shiboukou" style="width: 100px" />
                    <span>偏差値：</span>
                    <input type="text" v-model="ichiji.hensachi" style="width: 50px" />
                  </div>
                </td>

                <td>
                  <div>
                    <input type="radio" id="needs_value_1" v-model="ichiji.needs" value="1" />
                    <label for="needs_value_1">ランナーでやるつもり</label>

                    <input type="radio" id="needs_value_2" v-model="ichiji.needs" value="2" />
                    <label for="needs_value_2">急いで探している</label>
                  </div>
                  <div>
                    <input type="radio" id="needs_value_3" v-model="ichiji.needs" value="3" />
                    <label for="needs_value_3">聞いてから考える</label>

                    <input type="radio" id="needs_value_4" v-model="ichiji.needs" value="4" />
                    <label for="needs_value_4">即決しない</label>

                    <input type="radio" id="needs_value_5" v-model="ichiji.needs" value="5" />
                    <label for="needs_value_5">とりあえず話だけ</label>
                  </div>
                  <div>
                    <input type="radio" id="needs_value_6" v-model="ichiji.needs" value="6" />
                    <label for="needs_value_6">塾含め検討中</label>

                    <input type="radio" id="needs_value_7" v-model="ichiji.needs" value="7" />
                    <label for="needs_value_7">KKのみで検討中</label>
                  </div>
                </td>
              </tr>

              <tr>
                <th colspan="2">料金対応</th>
              </tr>

              <tr>
                <td colspan="2">
                  <div>
                    <input type="checkbox" id="ryoukin1" v-model="ichiji.ryoukin1" />
                    <label for="ryoukin1">時給</label>

                    <input type="checkbox" id="ryoukin2" v-model="ichiji.ryoukin2" />
                    <label for="ryoukin2">交通費</label>

                    <input type="checkbox" id="ryoukin3" v-model="ichiji.ryoukin3" />
                    <label for="ryoukin3">入会金(&yen;22,000)</label>

                    <input type="checkbox" id="ryoukin4" v-model="ichiji.ryoukin4" />
                    <label for="ryoukin4">保証金(&yen;22,000)</label>

                    <input type="checkbox" id="ryoukin5" v-model="ichiji.ryoukin5" />
                    <label for="ryoukin5">同時指導</label>

                    <input type="checkbox" id="ryoukin6" v-model="ichiji.ryoukin6" />
                    <label for="ryoukin6">テキスト代</label>
                  </div>
                  <div>
                    <input type="checkbox" id="ryoukin7" v-model="ichiji.ryoukin7" />
                    <label for="ryoukin7">管理費</label>

                    <input type="checkbox" id="ryoukin8" v-model="ichiji.ryoukin8" />
                    <label for="ryoukin8">未就&yen;5,000</label>

                    <input type="checkbox" id="ryoukin9" v-model="ichiji.ryoukin9" />
                    <label for="ryoukin9">小&yen;8,000</label>

                    <input type="checkbox" id="ryoukin10" v-model="ichiji.ryoukin10" />
                    <label for="ryoukin10">中&yen;11,000</label>

                    <input type="checkbox" id="ryoukin11" v-model="ichiji.ryoukin11" />
                    <label for="ryoukin11">中3年10月~高&yen;15,000</label>

                    <input type="checkbox" id="ryoukin12" v-model="ichiji.ryoukin12" />
                    <label for="ryoukin12">母子・父子&yen;11,000</label>

                    <input type="checkbox" id="ryoukin13" v-model="ichiji.ryoukin13" />
                    <label for="ryoukin13">CB</label>
                  </div>
                  <div>
                    <input type="checkbox" id="ryoukin14" v-model="ichiji.ryoukin14" />
                    <label for="ryoukin14">月負担</label>

                    <input type="text" v-model="ichiji.ryoukin15" />
                  </div>
                </td>
              </tr>

              <tr>
                <th colspan="2">特記事項</th>
              </tr>

              <tr>
                <td colspan="2">
                  <div>
                    <input type="checkbox" id="tokki1" v-model="ichiji.tokki1" />
                    <label for="tokki1">不登校</label>

                    <input type="text" v-model="ichiji.tokki1_note" style="width: 100px" />

                    <input type="checkbox" id="tokki2" v-model="ichiji.tokki2" />
                    <label for="tokki2">障害</label>

                    <input type="text" v-model="ichiji.tokki2_note" style="width: 100px" />

                    <input type="checkbox" id="tokki3" v-model="ichiji.tokki3" />
                    <label for="tokki3">母子・父子家庭</label>

                    <input type="checkbox" id="tokki4" v-model="ichiji.tokki4" />
                    <label for="tokki4">ファミレス営業</label>

                    <input type="checkbox" id="tokki5" v-model="ichiji.tokki5" />
                    <label for="tokki5">二件同時</label>
                  </div>
                  <div>
                    <input type="checkbox" id="tokki6" v-model="ichiji.tokki6" />
                    <label for="tokki6">女性希望：</label>

                    <input type="checkbox" id="tokki7" v-model="ichiji.tokki7" />
                    <label for="tokki7">体験のみ男性可</label>

                    <input type="checkbox" id="tokki8" v-model="ichiji.tokki8" />
                    <label for="tokki8">子嫌</label>

                    <input type="checkbox" id="tokki9" v-model="ichiji.tokki9" />
                    <label for="tokki9">内緒飛込</label>

                    <input type="checkbox" id="tokki10" v-model="ichiji.tokki10" />
                    <label for="tokki10">テキストネック</label>

                    <input type="checkbox" id="tokki11" v-model="ichiji.tokki11" />
                    <label for="tokki11">外人(弱・強)</label>

                    <input type="checkbox" id="tokki12" v-model="ichiji.tokki12" />
                    <label for="tokki12">時間制限</label>

                    <input type="text" v-model="ichiji.tokki12_note" style="width: 90px" />
                    <span>迄</span>
                  </div>
                </td>
              </tr>

              <tr>
                <td colspan="2">
                  <textarea
                    name=""
                    id=""
                    cols="30"
                    rows="5"
                    v-model="appointment.note"
                    style="width: 100%"
                  ></textarea>
                </td>
              </tr>
            </table>

            <table style="flex: 20%">
              <tr>
                <th>チェック</th>
              </tr>
              <tr>
                <td>
                  <div>
                    <input
                      type="checkbox"
                      id="transmission_item_company"
                      v-model="appointment.transmission_item_company"
                    />
                    <label for="transmission_item_company">会社名伝える</label>
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="transmission_item_course"
                      v-model="appointment.transmission_item_course"
                    />
                    <label for="transmission_item_course">テキスト有無</label>
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="transmission_item_requiredtime"
                      v-model="appointment.transmission_item_requiredtime"
                    />
                    <label for="transmission_item_requiredtime">2時間</label>
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="zenkaku"
                      v-model="ichiji.zenkaku"
                    />
                    <label for="zenkaku">前日確認</label>
                  </div>

                  <div>
                    <input
                      type="checkbox" 
                      id="tegami"
                      v-model="ichiji.tegami"
                    />
                    <label for="tegami">体験前手紙必読</label>
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="transmission_item_visitor"
                      v-model="appointment.transmission_item_visitor"
                    />
                    <label for="transmission_item_visitor">adが行く</label>
                  </div>

                  <div>
                    <input
                      type="checkbox"
                      id="harigami"
                      v-model="ichiji.harigami"
                    />
                    <label for="harigami">貼紙を見たか聞く</label>
                  </div>
                </td>
              </tr>

              <tr>
                <th>空きが出たら</th>
              </tr>
              <tr>
                <td>
                  <div>
                    <input type="radio" id="aki2_value_1" v-model="ichiji.aki2" value="1" />
                    <label for="aki2_value_1">○</label>

                    <input type="radio" id="aki2_value_2" v-model="ichiji.aki2" value="2" />
                    <label for="aki2_value_2">×</label>
                  </div>
                </td>
              </tr>

              <tr>
                <th>事務から</th>
              </tr>
              <tr>
                <td>
                  <div>
                    <span>交通費:</span>
                    <input type="text" v-model="ichiji.koutsuuhi" style="width: 50px" />
                    <span>円</span>
                  </div>
                  <div>
                    <span>特記事項</span>
                  </div>
                  <div>
                    <textarea name="" id="" cols="20" rows="5" v-model="ichiji.notice"></textarea>
                  </div>
                  <div>
                    <input type="checkbox" id="cxl" v-model="ichiji.cxl" />
                    <label for="cxl">最悪CXLになる可能性がある</label>
                  </div>
                </td>
              </tr>

              <tr>
                <th>TEL履歴</th>
              </tr>
              <tr>
                <td>
                  <div>
                    <textarea name="" id="" cols="20" rows="5" v-model="ichiji.rireki"></textarea>
                  </div>
                </td>
              </tr>
            </table>

          </div>

          <!-- <hr /> -->
          <!-- 勧誘目的は？transmission_item_purpose -->

          <table>
            <tr>
              <th>
                問合せ日
                <span class="req">*</span>
              </th>
              <td>
                <input type="text" v-model="appointment.contact_date" style="width: 100px"/>
              </td>

              <th>
                問合せ方法
                <span class="req">*</span>
              </th>
              <td>
                <input
                  type="radio"
                  name="contact_method"
                  id="contact_method_1"
                  value="1"
                  v-model="appointment.contact_method"
                />
                <label for="contact_method_1">TEL</label>

                <input
                  type="radio"
                  name="contact_method"
                  id="contact_method_2"
                  value="2"
                  v-model="appointment.contact_method"
                />
                <label for="contact_method_2">MAIL</label>

                <input
                  type="radio"
                  name="contact_method"
                  id="contact_method_3"
                  value="3"
                  v-model="appointment.contact_method"
                />
                <label for="contact_method_3">その他</label>
              </td>
            </tr>

            <tr>
              <th>
                問合せ結果
                <span class="req">*</span>
              </th>
              <td>
                <multiselect
                  v-model="watch.support"
                  :options="support"
                  label="name"
                  :searchable="true"
                  :show-labels="false"
                  placeholder=""
                ></multiselect>
              </td>

              <th>問合せ結果詳細</th>
              <td>
                <multiselect
                  v-model="watch.missing_detail"
                  :options="missing_detail"
                  label="name"
                  :searchable="true"
                  :show-labels="false"
                  placeholder=""
                ></multiselect>
              </td>
            </tr>

            <tr>
              <th>今後連絡できるか</th>
              <td>
                <multiselect
                  v-model="watch.contact_later"
                  :options="contact_later"
                  label="name"
                  :searchable="true"
                  :show-labels="false"
                  placeholder=""
                ></multiselect>
              </td>

              <th>次回連絡予定日</th>
              <td>
                <input type="text" v-model="appointment.next_contact_date" />
              </td>

              <th>次回連絡日手段</th>
              <td>
                <multiselect
                  v-model="watch.next_contact_method"
                  :options="next_contact_method"
                  label="name"
                  :searchable="true"
                  :show-labels="false"
                  placeholder=""
                ></multiselect>
              </td>
            </tr>
          </table>

          <!-- <hr /> -->
          <!-- いらなくなる？ -->
          <!-- <hr /> -->
          <!--  -->
          <!-- <div> -->
          <!--   <span>APメモ: memo</span> -->
          <!--   <input type="text" v&#45;model="appointment.memo" /> -->
          <!-- </div> -->
          <!-- <div> -->
          <!--   <span>店種類: shop_type</span> -->
          <!--   <input type="text" v&#45;model="appointment.shop_type" /> -->
          <!-- </div> -->
          <!-- <div> -->
          <!--   <span>DM届いた月: dm</span> -->
          <!--   <input type="text" v&#45;model="appointment.dm" /> -->
          <!-- </div> -->
          <!-- <div> -->
          <!--   <span>希望曜日: request_of_day_of_week</span> -->
          <!--   <input type="text" v&#45;model="appointment.request_of_day_of_week" /> -->
          <!-- </div> -->
          <!-- <div> -->
          <!--   <span>希望曜日備考: request_of_day_of_week_note</span> -->
          <!--   <input -->
          <!--     type="text" -->
          <!--     v&#45;model="appointment.request_of_day_of_week_note" -->
          <!--   /> -->
          <!-- </div> -->
          <!-- <div> -->
          <!--   <span>父親の絡み: fathers_involvement</span> -->
          <!--   <input type="text" v&#45;model="appointment.fathers_involvement" /> -->
          <!-- </div> -->
          <!-- <div> -->
          <!--   <span>メイン成績: achievement</span> -->
          <!--   <input type="text" v&#45;model="appointment.achievement" /> -->
          <!-- </div> -->
          <!-- <div> -->
          <!--   <span>メイン習い事: learning</span> -->
          <!--   <input type="text" v&#45;model="appointment.learning" /> -->
          <!-- </div> -->
          <!-- <div> -->
          <!--   <span>メイン習い事いつから: learning_start_period</span> -->
          <!--   <input type="text" v&#45;model="appointment.learning_start_period" /> -->
          <!-- </div> -->
          <!-- <div> -->
          <!--   <span>メイン習い事きっかけ: learning_nervous</span> -->
          <!--   <input type="text" v&#45;model="appointment.learning_nervous" /> -->
          <!-- </div> -->
          <!-- <div> -->
          <!--   <span>メイン習い事成果: learning_result</span> -->
          <!--   <input type="text" v&#45;model="appointment.learning_result" /> -->
          <!-- </div> -->
          <!-- <div> -->
          <!--   <span>メイン習い事成果: learning_continuation</span> -->
          <!--   <input type="text" v&#45;model="appointment.learning_continuation" /> -->
          <!-- </div> -->
          <!-- サブも同様 -->

          <!-- <hr /> -->
          <!-- AP時いらない -->
          <!-- <hr /> -->
          <!--  -->
          <!-- <div> -->
          <!--   <span>営業結果: result</span> -->
          <!--   <input type="text" v&#45;model="appointment.result" /> -->
          <!-- </div> -->
          <!-- <div> -->
          <!--   <span>DM情報: dm_information</span> -->
          <!--   <input type="text" v&#45;model="appointment.dm_information" /> -->
          <!-- </div> -->
        </div>

        <div class="m-modal__inner__bottom no-print">
          <btn @click.native="postAppointment">登録</btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
let jsonp = require('jsonp')
export default {
  name: 'AppointmentsModal',

  data () {
    return {
      modal: {
        isShow: true
      },

      appointment: {
        family_id: '',
        state: 0,
        f_name: '',
        l_name: '',
        f_name_kana: '',
        l_name_kana: '',
        zip: '',
        pref: 0,
        geometry: '',
        address1: '',
        address2: '',
        tel1: '',
        tel2: '',
        fax: '',
        mail: '',
        contact_date: moment().format('YYYY/MM/DD'),
        support: 0,
        missing_detail: 0,
        contact_later: 0,
        next_contact_date: '0001/01/01',
        next_contact_method: 0,
        acquisition_date: '',
        ap_type: 0,
        hp_type: 0,
        gender: 0,
        school_type: 0,
        school_stage: 0,
        school_name: '',
        grade: 0,
        shop_name: '',
        contact_method: '',
        hp_browse: 0,
        visit_date: '',
        person: '',
        note: '',
        visit_time: '',
        sending_date: '',
        sending_time: '',
        contact_person: 0,
        parking: 0,
        parking_note: '',
        sub_f_name: '',
        sub_l_name: '',
        sub_f_name_kana: '',
        sub_l_name_kana: '',
        sub_grade: 0,
        sub_school_type: 0,
        sub_school_stage: 0,
        sub_school_name: '',
        sub_gender: 0,
        sending_method: 0,
        confirm_check: 0,
        preferred_contact: 0,
        contact_timezone: '',
        transmission_item_company: 0,
        transmission_item_course: 0,
        transmission_item_visitor: 0,
        transmission_item_purpose: 0,
        transmission_item_requiredtime: 0,

        // iranai
        memo: '',
        dm: '',
        shop_type: 0,
        request_of_day_of_week: '',
        request_of_day_of_week_note: '',
        fathers_involvement: 0,
        achievement: '',
        learning: '',
        learning_start_period: '',
        learning_nervous: '',
        learning_result: 0,
        learning_continuation: 0,
        sub_achievement: '',
        sub_learning: '',
        sub_learning_start_period: '',
        sub_learning_nervous: '',
        sub_learning_result: 0,
        sub_learning_continuation: 0,

        dm_information: 0, // !
        result: 0, // !

        sending_productsArray: [], // !
        attendedArray: [], // !
        noticesArray: [],
        mediumArray: [] // !
      },

      ichiji: {
        denwa: '',
        fd: '',
        toifd: '',
        other: '',
        ap_settei: 0,
        contact_person_other: '',
        contact_person_type: '',
        siryo_person: '',
        acquisition_youbi: '',
        acquisition_time: '',
        bukatsu: '',
        sub_bukatsu: '',
        bunri: 0,
        sub_bunri: 0,
        cource: '',
        sub_cource: '',
        station: '',
        toho: '',
        minutes: '',
        bus: '',
        bus_time: '',
        parking_home: '',
        parking_raikyaku: '',
        parking_coin: '',
        visit_youbi: '',
        hayame: '',
        zenkaku_note: '',
        attended_other: '',
        attended_other_note: '',
        oshirase: '',
        aki: 0,
        mikakunin: '',
        bikou: '',
        kibou1_date: '',
        kibou1_youbi: '',
        kibou2_date: '',
        kibou2_youbi: '',
        ei: '',
        su: '',
        koku: '',
        ri: '',
        sya: '',
        zen: '',
        seiseki_note: '',
        teiki: '',
        jitsuryoku: '',
        shukan: 0,
        shukan_note: '',
        naraigoto: 0,
        naraigoto_type1: 0,
        naraigoto_type2: 0,
        naraigoto_type3: 0,
        naraigoto_type4: 0,
        naraigoto_name: '',
        naraigoto_week: '',
        naraigoto_time: '',
        naraigoto_kyouka: '',
        yame_yaruki: '',
        yame_seiseki: '',
        yame_huniki: '',
        yame_sensei: '',
        yame_other: '',
        kento: 0,
        kiitakoto: 0,
        kiitakoto_note: '',
        kikuyotei: 0,
        kikuyotei_note: '',
        batting: '',
        jukenkibou: 0,
        shiboukou: '',
        hensachi: '',
        needs: 0,
        ryoukin1: 0,
        ryoukin2: 0,
        ryoukin3: 0,
        ryoukin4: 0,
        ryoukin5: 0,
        ryoukin6: 0,
        ryoukin7: 0,
        ryoukin8: 0,
        ryoukin9: 0,
        ryoukin10: 0,
        ryoukin11: 0,
        ryoukin12: 0,
        ryoukin13: 0,
        ryoukin14: 0,
        ryoukin15: '',
        tokki1: 0,
        tokki1_note: '',
        tokki2: 0,
        tokki2_note: '',
        tokki3: 0,
        tokki4: 0,
        tokki5: 0,
        tokki6: 0,
        tokki7: 0,
        tokki8: 0,
        tokki9: 0,
        tokki10: 0,
        tokki11: 0,
        tokki12: 0,
        tokki12_note: '',
        zenkaku: 0,
        tegami: 0,
        harigami: 0,
        koutsuuhi: '',
        notice: '',
        cxl: 0,
        rireki: ''
      },

      watch: {
        state: '',
        school_stage: '',
        grade: '',
        sub_school_stage: '',
        sub_grade: '',
        pref: '',
        support: '',
        missing_detail: '',
        contact_later: '',
        next_contact_method: ''
      }
    }
  },

  created () {
    this.getPrefs()
    console.log('created!!')
  },

  computed: {
    state () {
      return this.$store.getters['appointments/state']
    },

    school_stage () {
      return this.$store.getters['appointments/school_stage']
    },

    grade () {
      return this.$store.getters['appointments/grade']
    },

    support () {
      return this.$store.getters['appointments/support']
    },

    missing_detail () {
      return this.$store.getters['appointments/missing_detail']
    },

    contact_later () {
      return this.$store.getters['appointments/contact_later']
    },

    next_contact_method () {
      return this.$store.getters['appointments/next_contact_method']
    },

    prefs () {
      return this.$store.getters.prefs.reverse()
    },

    user () {
      return this.$store.getters.user
    },

    sending_products () {
      let sending_products = this.appointment.sending_productsArray.join()
      return sending_products
    },

    attended () {
      let attended = this.appointment.attendedArray.join()
      return attended
    },

    notices () {
      let notices = this.appointment.noticesArray.join()
      return notices
    }

    // // validation
    // address1Errors () {
    //   return this.appointment.address1 ? [] : ['住所(市区町村・番地)']
    // },
    //
    // contact_dateErrors () {
    //   return this.appointment.contact_date ? [] : ['問い合わせ日']
    // },
    //
    // acquisition_dateErrors () {
    //   return this.appointment.acquisition_date ? [] : ['取得日']
    // },
    //
    // supportErrors () {
    //   return this.appointment.support ? [] : ['AP結果']
    // },
    //
    // contact_methodErrors () {
    //   return this.appointment.contact_method ? [] : ['AP連絡方法']
    // },
    //
    // visit_dateErrors () {
    //   return this.appointment.visit_date ? [] : ['訪問日']
    // },
    //
    // sending_dateErrors () {
    //   return this.appointment.sending_date ? [] : ['郵送・FAX / 予定日']
    // },
    //
    // errors: function () {
    //   let errors = [].concat(
    //     this.address1Errors,
    //     this.contact_dateErrors,
    //     this.acquisition_dateErrors,
    //     this.supportErrors,
    //     this.contact_methodErrors,
    //     this.visit_dateErrors,
    //     this.sending_dateErrors
    //   )
    //   let errorsJoin = errors.join('・')
    //   return errorsJoin
    // },
    // valid: function () {
    //   return !this.errors
    // }
  },

  watch: {
    'watch.state': function (now, old) {
      if (now) {
        this.appointment.state = now.value
      }
    },

    'watch.pref': function (now, old) {
      if (now) {
        this.appointment.pref = now.id
        this.appointment.geometry = now.name
      }
    },

    'watch.support': function (now, old) {
      if (now) {
        this.appointment.support = now.value
      }
    },

    'watch.missing_detail': function (now, old) {
      if (now) {
        this.appointment.missing_detail = now.value
      }
    },

    'watch.contact_later': function (now, old) {
      if (now) {
        this.appointment.contact_later = now.value
      }
    },

    'watch.school_stage': function (now, old) {
      if (now) {
        this.appointment.school_stage = now.value
      }
    },

    'watch.grade': function (now, old) {
      if (now) {
        this.appointment.grade = now.value
      }
    },

    'watch.next_contact_method': function (now, old) {
      if (now) {
        this.appointment.next_contact_method = now.value
      }
    },

    'watch.sub_grade': function (now, old) {
      if (now) {
        this.appointment.sub_grade = now.value
      }
    },

    'watch.sub_school_stage': function (now, old) {
      if (now) {
        this.appointment.sub_school_stage = now.value
      }
    }
  },

  methods: {
    getPrefs () {
      this.$store.dispatch('getPrefs')
    },

    showModal () {
      this.modal.isShow = !this.modal.isShow
    },

    postAppointment () {
      if (this.appointment.mediumArray.length === 0) {
        alert('媒体が選択されていません')
      } else {
        this.$store.dispatch('postAppointment', {
          this: this,
          appointment: this.appointment,
          sending_products: this.sending_products,
          attended: this.attended,
          notices: this.notices,
          watch: this.watch,
          reset: this.reset
        })
        this.save()
      }
    },

    getYubin (e) {
      let that = this
      // console.log(e)
      const value = e.target.value
      if (value.length > 5 && that.appointment.address1 === '') {
        jsonp('http://zipcloud.ibsnet.co.jp/api/search?zipcode=' + value, null, function (err, data) {
          if (err) {
            // error
            console.error(err.message)
          } else {
            // success
            console.log(data)
            if (data.results[0].address1 === '北海道') {
              that.watch.pref = { name: '1. 北海道', id: 1 }
            } else if (data.results[0].address1 === '青森県') {
              that.watch.pref = { name: '2. 青森県', id: 2 }
            } else if (data.results[0].address1 === '秋田県') {
              that.watch.pref = { name: '3. 秋田県', id: 3 }
            } else if (data.results[0].address1 === '岩手県') {
              that.watch.pref = { name: '4. 岩手県', id: 4 }
            } else if (data.results[0].address1 === '山形県') {
              that.watch.pref = { name: '5. 山形県', id: 5 }
            } else if (data.results[0].address1 === '宮城県') {
              that.watch.pref = { name: '6. 宮城県', id: 6 }
            } else if (data.results[0].address1 === '福島県') {
              that.watch.pref = { name: '7. 福島県', id: 7 }
            } else if (data.results[0].address1 === '栃木県') {
              that.watch.pref = { name: '8. 栃木県', id: 8 }
            } else if (data.results[0].address1 === '山梨県') {
              that.watch.pref = { name: '9. 山梨県', id: 9 }
            } else if (data.results[0].address1 === '群馬県') {
              that.watch.pref = { name: '10. 群馬県', id: 10 }
            } else if (data.results[0].address1 === '茨城県') {
              that.watch.pref = { name: '11. 茨城県', id: 11 }
            } else if (data.results[0].address1 === '千葉県') {
              that.watch.pref = { name: '12. 千葉県', id: 12 }
            } else if (data.results[0].address1 === '埼玉県') {
              that.watch.pref = { name: '13. 埼玉県', id: 13 }
            } else if (data.results[0].address1 === '東京都') {
              that.watch.pref = { name: '14. 東京都', id: 14 }
            } else if (data.results[0].address1 === '神奈川県') {
              that.watch.pref = { name: '15. 神奈川県', id: 15 }
            } else if (data.results[0].address1 === '静岡県') {
              that.watch.pref = { name: '16. 静岡県', id: 16 }
            } else if (data.results[0].address1 === '長野県') {
              that.watch.pref = { name: '17. 長野県', id: 17 }
            } else if (data.results[0].address1 === '愛知県') {
              that.watch.pref = { name: '18. 愛知県', id: 18 }
            } else if (data.results[0].address1 === '岐阜県') {
              that.watch.pref = { name: '19. 岐阜県', id: 19 }
            } else if (data.results[0].address1 === '新潟県') {
              that.watch.pref = { name: '20. 新潟県', id: 20 }
            } else if (data.results[0].address1 === '富山県') {
              that.watch.pref = { name: '21. 富山県', id: 21 }
            } else if (data.results[0].address1 === '石川県') {
              that.watch.pref = { name: '22. 石川県', id: 22 }
            } else if (data.results[0].address1 === '福井県') {
              that.watch.pref = { name: '23. 福井県', id: 23 }
            } else if (data.results[0].address1 === '滋賀県') {
              that.watch.pref = { name: '24. 滋賀県', id: 24 }
            } else if (data.results[0].address1 === '京都府') {
              that.watch.pref = { name: '25. 京都府', id: 25 }
            } else if (data.results[0].address1 === '三重県') {
              that.watch.pref = { name: '26. 三重県', id: 26 }
            } else if (data.results[0].address1 === '和歌山県') {
              that.watch.pref = { name: '27. 和歌山県', id: 27 }
            } else if (data.results[0].address1 === '奈良県') {
              that.watch.pref = { name: '28. 奈良県', id: 28 }
            } else if (data.results[0].address1 === '大阪府') {
              that.watch.pref = { name: '29. 大阪府', id: 29 }
            } else if (data.results[0].address1 === '兵庫県') {
              that.watch.pref = { name: '30. 兵庫県', id: 30 }
            } else if (data.results[0].address1 === '鳥取県') {
              that.watch.pref = { name: '31. 鳥取県', id: 31 }
            } else if (data.results[0].address1 === '島根県') {
              that.watch.pref = { name: '32. 島根県', id: 32 }
            } else if (data.results[0].address1 === '岡山県') {
              that.watch.pref = { name: '33. 岡山県', id: 33 }
            } else if (data.results[0].address1 === '広島県') {
              that.watch.pref = { name: '34. 広島県', id: 34 }
            } else if (data.results[0].address1 === '山口県') {
              that.watch.pref = { name: '35. 山口県', id: 35 }
            } else if (data.results[0].address1 === '高知県') {
              that.watch.pref = { name: '36. 高知県', id: 36 }
            } else if (data.results[0].address1 === '徳島県') {
              that.watch.pref = { name: '37. 徳島県', id: 37 }
            } else if (data.results[0].address1 === '香川県') {
              that.watch.pref = { name: '38. 香川県', id: 38 }
            } else if (data.results[0].address1 === '愛媛県') {
              that.watch.pref = { name: '39. 愛媛県', id: 39 }
            } else if (data.results[0].address1 === '福岡県') {
              that.watch.pref = { name: '40. 福岡県', id: 40 }
            } else if (data.results[0].address1 === '佐賀県') {
              that.watch.pref = { name: '41. 佐賀県', id: 41 }
            } else if (data.results[0].address1 === '長崎県') {
              that.watch.pref = { name: '42. 長崎県', id: 42 }
            } else if (data.results[0].address1 === '熊本県') {
              that.watch.pref = { name: '43. 熊本県', id: 43 }
            } else if (data.results[0].address1 === '宮崎県') {
              that.watch.pref = { name: '44. 宮崎県', id: 44 }
            } else if (data.results[0].address1 === '大分県') {
              that.watch.pref = { name: '45. 大分県', id: 45 }
            } else if (data.results[0].address1 === '鹿児島県') {
              that.watch.pref = { name: '46. 鹿児島県', id: 46 }
            } else if (data.results[0].address1 === '沖縄県') {
              that.watch.pref = { name: '47. 沖縄県', id: 47 }
            }
            that.appointment.address1 = data.results[0].address2 + data.results[0].address3
          }
        })
      }
    },

    save () {
      // alert('save')
      let arr = []
      let obj = {
        state: this.watch.state,
        f_name: this.appointment.f_name,
        l_name: this.appointment.l_name,
        f_name_kana: this.appointment.f_name_kana,
        l_name_kana: this.appointment.l_name_kana,
        zip: this.appointment.zip,
        pref: this.watch.pref,
        address1: this.appointment.address1,
        address2: this.appointment.address2,
        tel1: this.appointment.tel1,
        tel2: this.appointment.tel2,
        fax: this.appointment.fax,
        mail: this.appointment.mail,
        contact_date: this.appointment.contact_date,
        support: this.watch.support,
        missing_detail: this.watch.missing_detail,
        contact_later: this.watch.contact_later,
        next_contact_date: this.appointment.next_contact_date,
        next_contact_method: this.appointment.next_contact_method,
        result: this.watch.result,
        acquisition_date: this.appointment.acquisition_date,
        ap_type: this.appointment.ap_type,
        mediumArray: this.appointment.mediumArray,
        hp_type: this.appointment.hp_type,
        gender: this.appointment.gender,
        school_type: this.appointment.school_type,
        school_stage: this.watch.school_stage,
        school_name: this.appointment.school_name,
        grade: this.watch.grade,
        memo: this.appointment.memo,
        dm: this.appointment.dm,
        dm_information: this.watch.dm_information,
        shop_type: this.watch.shop_type,
        shop_name: this.appointment.shop_name,
        contact_method: this.appointment.contact_method,
        hp_browse: this.watch.hp_browse,
        person: this.appointment.person,
        note: this.appointment.note,
        visit_date: this.appointment.visit_date,
        visit_time: this.appointment.visit_time,
        request_of_day_of_week: this.appointment.request_of_day_of_week,
        request_of_day_of_week_note: this.appointment
          .request_of_day_of_week_note,
        sending_date: this.appointment.sending_date,
        sending_time: this.appointment.sending_time,
        contact_person: this.appointment.contact_person,
        parking: this.appointment.parking,
        parking_note: this.appointment.parking_note,
        sub_f_name: this.appointment.sub_f_name,
        sub_l_name: this.appointment.sub_l_name,
        sub_f_name_kana: this.appointment.sub_f_name_kana,
        sub_l_name_kana: this.appointment.sub_l_name_kana,
        sub_grade: this.watch.sub_grade,
        sub_school_type: this.appointment.sub_school_type,
        sub_school_stage: this.watch.sub_school_stage,
        sub_school_name: this.appointment.sub_school_name,
        sub_gender: this.appointment.sub_gender,
        achievement: this.appointment.achievement,
        learning: this.appointment.learning,
        learning_start_period: this.appointment.learning_start_period,
        learning_nervous: this.appointment.learning_nervous,
        learning_result: this.watch.learning_result,
        learning_continuation: this.watch.learning_continuation,
        sub_achievement: this.appointment.sub_achievement,
        sub_learning: this.appointment.sub_learning,
        sub_learning_start_period: this.appointment.sub_learning_start_period,
        sub_learning_nervous: this.appointment.sub_learning_nervous,
        sub_learning_result: this.watch.sub_learning_result,
        sub_learning_continuation: this.watch.sub_learning_continuation,
        attendedArray: this.appointment.attendedArray,
        fathers_involvement: this.appointment.fathers_involvement,
        noticesArray: this.appointment.noticesArray,
        sending_productsArray: this.appointment.sending_productsArray,
        sending_method: this.appointment.sending_method,
        preferred_contact: this.appointment.preferred_contact,
        contact_timezone: this.appointment.contact_timezone,
        confirm_check: this.appointment.confirm_check,
        transmission_item_company: this.appointment.transmission_item_company,
        transmission_item_course: this.appointment.transmission_item_course,
        transmission_item_visitor: this.appointment.transmission_item_visitor,
        transmission_item_purpose: this.appointment.transmission_item_purpose,
        transmission_item_requiredtime: this.appointment
          .transmission_item_requiredtime
      }
      arr.push(obj)
      let setjson = JSON.stringify(obj)
      localStorage.setItem('AppointmentsAdd', setjson)
    },

    get () {
      // alert('get')
      let getjson = localStorage.getItem('AppointmentsAdd')
      let obj = JSON.parse(getjson)

      this.watch.state = obj['state']
      this.appointment.f_name = obj['f_name']
      this.appointment.l_name = obj['l_name']
      this.appointment.f_name_kana = obj['f_name_kana']
      this.appointment.l_name_kana = obj['l_name_kana']
      this.appointment.zip = obj['zip']
      this.watch.pref = obj['pref']
      this.appointment.address1 = obj['address1']
      this.appointment.address2 = obj['address2']
      this.appointment.tel1 = obj['tel1']
      this.appointment.tel2 = obj['tel2']
      this.appointment.fax = obj['fax']
      this.appointment.mail = obj['mail']
      this.appointment.contact_date = obj['contact_date']
      this.watch.support = obj['support']
      this.watch.missing_detail = obj['missing_detail']
      this.watch.contact_later = obj['contact_later']
      this.appointment.next_contact_date = obj['next_contact_date']
      this.watch.next_contact_method = obj['next_contact_method']
      this.watch.result = obj['result']
      this.appointment.acquisition_date = obj['acquisition_date']
      this.appointment.ap_type = obj['ap_type']
      this.appointment.mediumArray = obj['mediumArray']
      this.appointment.hp_type = obj['hp_type']
      this.appointment.gender = obj['gender']
      this.appointment.school_type = obj['school_type']
      this.watch.school_stage = obj['school_stage']
      this.appointment.school_name = obj['school_name']
      this.watch.grade = obj['grade']
      this.appointment.memo = obj['memo']
      this.appointment.dm = obj['dm']
      this.watch.dm_information = obj['dm_information']
      this.watch.shop_type = obj['shop_type']
      this.appointment.shop_name = obj['shop_name']
      this.appointment.contact_method = obj['contact_method']
      this.watch.hp_browse = obj['hp_browse']
      this.appointment.person = obj['person']
      this.appointment.note = obj['note']
      this.appointment.visit_date = obj['visit_date']
      this.appointment.visit_time = obj['visit_time']
      this.appointment.request_of_day_of_week = obj['request_of_day_of_week']
      this.appointment.request_of_day_of_week_note =
        obj['request_of_day_of_week_note']
      this.appointment.sending_date = obj['sending_date']
      this.appointment.sending_time = obj['sending_time']
      this.appointment.contact_person = obj['contact_person']
      this.appointment.parking = obj['parking']
      this.appointment.parking_note = obj['parking_note']
      this.appointment.sub_f_name = obj['sub_f_name']
      this.appointment.sub_l_name = obj['sub_l_name']
      this.appointment.sub_f_name_kana = obj['sub_f_name_kana']
      this.appointment.sub_l_name_kana = obj['sub_l_name_kana']
      this.watch.sub_grade = obj['sub_grade']
      this.appointment.sub_school_type = obj['sub_school_type']
      this.watch.sub_school_stage = obj['sub_school_stage']
      this.appointment.sub_school_name = obj['sub_school_name']
      this.appointment.sub_gender = obj['sub_gender']
      this.appointment.achievement = obj['achievement']
      this.appointment.learning = obj['learning']
      this.appointment.learning_start_period = obj['learning_start_period']
      this.appointment.learning_nervous = obj['learning_nervous']
      this.watch.learning_result = obj['learning_result']
      this.watch.learning_continuation = obj['learning_continuation']
      this.appointment.sub_achievement = obj['sub_achievement']
      this.appointment.sub_learning = obj['sub_learning']
      this.appointment.sub_learning_start_period =
        obj['sub_learning_start_period']
      this.appointment.sub_learning_nervous = obj['sub_learning_nervous']
      this.watch.sub_learning_result = obj['sub_learning_result']
      this.watch.sub_learning_continuation = obj['sub_learning_continuation']
      this.appointment.attendedArray = obj['attendedArray']
      this.appointment.fathers_involvement = obj['fathers_involvement']
      this.appointment.noticesArray = obj['noticesArray']
      this.appointment.sending_productsArray = obj['sending_productsArray']
      this.appointment.sending_method = obj['sending_method']
      this.appointment.preferred_contact = obj['preferred_contact']
      this.appointment.contact_timezone = obj['contact_timezone']
      this.appointment.confirm_check = obj['confirm_check']
      this.appointment.transmission_item_company =
        obj['transmission_item_company']
      this.appointment.transmission_item_course =
        obj['transmission_item_course']
      this.appointment.transmission_item_visitor =
        obj['transmission_item_visitor']
      this.appointment.transmission_item_purpose =
        obj['transmission_item_purpose']
      this.appointment.transmission_item_requiredtime =
        obj['transmission_item_requiredtime']
      // console.log(obj)
    },

    reset () {
      this.appointment.shop_name = ''
      this.appointment.mediumArray = []
      this.appointment.hp_type = 0
      this.ichiji.denwa = ''
      this.ichiji.fd = ''
      this.ichiji.toifd = ''
      this.ichiji.other = ''
      this.appointment.ap_type = 0
      this.ichiji.ap_settei = 0
      this.appointment.contact_person = 0
      this.ichiji.contact_person_other = ''
      this.ichiji.contact_person_type = ''
      this.appointment.sending_method = 0
      this.appointment.sending_date = ''
      this.appointment.sending_time = ''
      this.ichiji.siryo_person = ''
      this.ichiji.acquisition_youbi = ''
      this.ichiji.acquisition_time = ''
      this.ichiji.bukatsu = ''
      this.ichiji.sub_bukatsu = ''
      this.ichiji.bunri = ''
      this.ichiji.sub_bunri = ''
      this.ichiji.cource = ''
      this.ichiji.sub_cource = ''
      this.ichiji.station = ''
      this.ichiji.toho = ''
      this.ichiji.minutes = ''
      this.ichiji.bus = ''
      this.ichiji.bus_time = ''
      this.appointment.parking = 0
      this.ichiji.parking_home = ''
      this.ichiji.parking_raikyaku = ''
      this.ichiji.parking_coin = ''
      this.ichiji.visit_youbi = ''
      this.appointment.preferred_contact = 0
      this.ichiji.hayame = ''
      this.ichiji.zenkaku_note = ''
      this.ichiji.attended_other = ''
      this.ichiji.attended_other_note = ''
      this.ichiji.oshirase = ''
      this.ichiji.aki = 0
      this.ichiji.mikakunin = ''
      this.ichiji.bikou = ''
      this.ichiji.kibou1_date = ''
      this.ichiji.kibou1_youbi = ''
      this.ichiji.kibou2_date = ''
      this.ichiji.kibou2_youbi = ''
      this.ichiji.ei = ''
      this.ichiji.su = ''
      this.ichiji.koku = ''
      this.ichiji.ri = ''
      this.ichiji.sya = ''
      this.ichiji.zen = ''
      this.ichiji.seiseki_note = ''
      this.ichiji.teiki = ''
      this.ichiji.jitsuryoku = ''
      this.ichiji.shukan = 0
      this.ichiji.shukan_note = ''
      this.ichiji.naraigoto = 0
      this.ichiji.naraigoto_type1 = ''
      this.ichiji.naraigoto_type2 = ''
      this.ichiji.naraigoto_type3 = ''
      this.ichiji.naraigoto_type4 = ''
      this.ichiji.naraigoto_name = ''
      this.ichiji.naraigoto_week = ''
      this.ichiji.naraigoto_time = ''
      this.ichiji.naraigoto_kyouka = ''
      this.ichiji.yame_yaruki = ''
      this.ichiji.yame_seiseki = ''
      this.ichiji.yame_huniki = ''
      this.ichiji.yame_sensei = ''
      this.ichiji.yame_other = ''
      this.ichiji.kento = 0
      this.ichiji.kiitakoto = 0
      this.ichiji.kiitakoto_note = ''
      this.ichiji.kikuyotei = 0
      this.ichiji.kikuyotei_note = ''
      this.ichiji.batting = ''
      this.ichiji.jukenkibou = 0
      this.ichiji.shiboukou = ''
      this.ichiji.hensachi = ''
      this.ichiji.needs = 0
      this.ichiji.ryoukin1 = 0
      this.ichiji.ryoukin2 = 0
      this.ichiji.ryoukin3 = 0
      this.ichiji.ryoukin4 = 0
      this.ichiji.ryoukin5 = 0
      this.ichiji.ryoukin6 = 0
      this.ichiji.ryoukin7 = 0
      this.ichiji.ryoukin8 = 0
      this.ichiji.ryoukin9 = 0
      this.ichiji.ryoukin10 = 0
      this.ichiji.ryoukin11 = 0
      this.ichiji.ryoukin12 = 0
      this.ichiji.ryoukin13 = 0
      this.ichiji.ryoukin14 = 0
      this.ichiji.ryoukin15 = ''
      this.ichiji.tokki1 = 0
      this.ichiji.tokki1_note = ''
      this.ichiji.tokki2 = 0
      this.ichiji.tokki2_note = ''
      this.ichiji.tokki3 = 0
      this.ichiji.tokki4 = 0
      this.ichiji.tokki5 = 0
      this.ichiji.tokki6 = 0
      this.ichiji.tokki7 = 0
      this.ichiji.tokki8 = 0
      this.ichiji.tokki9 = 0
      this.ichiji.tokki10 = 0
      this.ichiji.tokki11 = 0
      this.ichiji.tokki12 = 0
      this.ichiji.tokki12_note = ''
      this.ichiji.zenkaku = 0
      this.ichiji.tegami = 0
      this.ichiji.harigami = 0
      this.ichiji.koutsuuhi = ''
      this.ichiji.notice = ''
      this.ichiji.cxl = 0
      this.ichiji.rireki = ''

      this.watch.state = 0
      this.appointment.f_name = ''
      this.appointment.l_name = ''
      this.appointment.f_name_kana = ''
      this.appointment.l_name_kana = ''
      this.appointment.zip = ''
      this.watch.pref = 0
      this.appointment.address1 = ''
      this.appointment.address2 = ''
      this.appointment.tel1 = ''
      this.appointment.tel2 = ''
      this.appointment.fax = ''
      this.appointment.mail = ''
      this.appointment.contact_date = moment().format('YYYY/MM/DD')
      this.watch.support = 0
      this.watch.missing_detail = 0
      this.watch.contact_later = 0
      this.appointment.next_contact_date = '0001/01/01'
      this.watch.next_contact_method = 0
      this.watch.result = 0
      this.appointment.acquisition_date = ''

      this.appointment.gender = 0
      this.appointment.school_type = 0
      this.watch.school_stage = 0
      this.appointment.school_name = ''
      this.watch.grade = 0
      this.appointment.memo = ''
      this.appointment.dm = ''
      this.watch.dm_information = 0
      this.watch.shop_type = 0
      this.appointment.shop_name = ''
      this.appointment.contact_method = ''
      this.watch.hp_browse = 0
      this.appointment.person = ''
      this.appointment.note = ''
      this.appointment.visit_date = ''
      this.appointment.visit_time = ''
      this.appointment.request_of_day_of_week = ''
      this.appointment.request_of_day_of_week_note = ''
      this.appointment.parking_note = ''
      this.appointment.sub_f_name = ''
      this.appointment.sub_l_name = ''
      this.appointment.sub_f_name_kana = ''
      this.appointment.sub_l_name_kana = ''
      this.watch.sub_grade = 0
      this.appointment.sub_school_type = 0
      this.watch.sub_school_stage = 0
      this.appointment.sub_school_name = ''
      this.appointment.sub_gender = 0
      this.appointment.achievement = ''
      this.appointment.learning = ''
      this.appointment.learning_start_period = ''
      this.appointment.learning_nervous = ''
      this.watch.learning_result = 0
      this.watch.learning_continuation = 0
      this.appointment.sub_achievement = ''
      this.appointment.sub_learning = ''
      this.appointment.sub_learning_start_period = ''
      this.appointment.sub_learning_nervous = ''
      this.watch.sub_learning_result = 0
      this.watch.sub_learning_continuation = 0
      this.appointment.attendedArray = []
      this.appointment.fathers_involvement = 0
      this.appointment.noticesArray = []
      this.appointment.sending_productsArray = []
      this.appointment.contact_timezone = ''
      this.appointment.confirm_check = ''
      this.appointment.transmission_item_company = 0
      this.appointment.transmission_item_course = 0
      this.appointment.transmission_item_visitor = 0
      this.appointment.transmission_item_purpose = 0
      this.appointment.transmission_item_requiredtime = 0
    }
  },

  // beforeRouteEnter (to, from, next) {
  //   next((vm) => {
  //     vm.get()
  //   })
  // },

  // beforeRouteLeave (to, from, next) {
  //   this.save()
  //   next()
  // },

  mounted () {}
}
</script>

<style lang="scss" scoped>
.req {
  color: red;
  background: none;
}

table {
  width: 100%;
  margin-top: 5px;
}

table,
tr,
th,
td {
  border-collapse: collapse;
  border: solid 1px black;
  font-size: 10px;
}

th {
  background: #41b883;
  color: #fff;
}

input[type='text'] {
  height: 20px;
}

input[type='checkbox'] {
  margin: 1px;
}

input[type='radio'] {
  margin: 1px;
}

.m-modal {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  z-index: 1003;
  &__inner {
    display: flex;
    flex-direction: column;
    min-width: 790px;
    min-height: 100%;
    max-height: 80%;
    /* overflow: scroll; */
    background-color: #fff;
    box-shadow: 0 0 10px #ccc;
    &__title {
      margin: 0.5rem;
      padding: 0.5rem;
      background: #37474f;
      color: #fff;
    }
    &__content {
      overflow: auto;
      padding: 0 0.5rem 0 0.5rem;
      flex: 1;
      position: relative;
    }
    &__bottom {
      padding: 0.5rem;
      align-self: flex-end;
      width: 100%;
      display: flex;
      .m-btn {
        margin-top: 0;
      }
    }
  }
}

.fa-tty {
  color: #37474f;
  font-size: 20px;
  padding: 5px;
  width: 35px;
  height: 35px;
  cursor: pointer;
  z-index: 1;
  padding: 8px 0 0 8px;
}

.fa-trash-restore {
  position: absolute;
  top: 5px;
  right: 5px;
  background: #fff;
  color: #37474f;
  font-size: 35px;
  padding: 5px;
  border-radius: 50px;
  width: 50px;
  height: 50px;
  cursor: pointer;
  z-index: 1;
  padding: 8px 0 0 10px;
}

.fa-times {
  position: absolute;
  top: 65px;
  right: 5px;
  background: #fff;
  color: #37474f;
  font-size: 40px;
  padding: 5px;
  border-radius: 50px;
  width: 50px;
  height: 50px;
  cursor: pointer;
  z-index: 1;
  padding: 5px 0 0 11px;
}

@media print {
  .no-print {
    display: none;
  }
}
</style>

<style lang="scss">
.AppointmentsModal {
  .multiselect {
    min-height: 26px;
  }
  .multiselect__tags {
    border: 0;
    min-height: 26px;
    padding: 0px 40px 0 2px;
    font-size: 0.85rem;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: 0.85rem;
  }
  .multiselect__select {
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .multiselect__placeholder {
    padding: 0.5rem 3px;
    margin: 0;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// AppointmentsModal.vue?2a4a3a6e